import {
  // RedmineBoolean,
  RedmineHeader,
  RedmineString,
  RedmineDate,
  RedmineInteger,
  RedmineDecimal,
  RedmineDateTime,
  RedmineEnum,
} from "pbas-vue-components";


function getHeaders(trackers, statuses, users, showMember, showPlan) {
  const headers = [
    new RedmineHeader({
      title: "Id",
      type: new RedmineInteger("id", {
        searchKey: "issue_id"
      }),
      visible: true,
      isIdentifier: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "components.emaildialog.subject",
      type: new RedmineString("subject", {
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }),
      visible: true,
      searchable: true,
    }),
    // new RedmineHeader({
    //   title: "headers.redmine.project",
    //   type: new RedmineString("project/name"),
    //   visible: true,
    //   searchable: false,
    //   orderByKey: "project",
    // }),
    // new RedmineHeader({
    //   title: "headers.redmine.tracker",
    //   type: new RedmineEnum("tracker/name", {
    //     searchKey: "tracker_id",
    //     dropdownItems: trackers
    //   }),
    //   visible: true,
    //   searchable: true,
    //   orderByKey: "tracker",
    // }),
    new RedmineHeader({
      title: "components.membernotesform.category",
      type: new RedmineString("custom_fields/Category", {
        getValue: (item) => {
          const items = item.custom_fields.filter(o=>o.id === 14);
          if (items.length === 0) {
            return "";
          }
          return items[0].value;
        },
      }),
      visible: true,
      searchable: false,
    }),
    // new RedmineHeader({
    //   title: "components.portal.demo_benefit_cards.source",
    //   type: new RedmineString("custom_fields/Source", {
    //     getValue: (item) => {
    //       // return item.custom_fields.filter(o=>o.id === 15)[0].value;
    //       console.log(item.custom_fields);
    //       const items = item.custom_fields.filter(o=>o.id === 15);
    //       if (items.length === 0) {
    //         return "";
    //       }
    //       return items[0].value;
    //     },
    //   }),
    //   visible: true,
    //   searchable: false,
    // }),
    new RedmineHeader({
      title: "globals.status",
      type: new RedmineEnum("status/name", {
        searchKey: "status_id",
        dropdownItems: statuses
      }),
      visible: true,
      searchable: true,
      orderByKey: "status",
    }),
    new RedmineHeader({
      title: "globals.priority",
      type: new RedmineString("priority/name"),
      visible: true,
      searchable: false,
      orderByKey: "priority",
    })
  ];
  const h2 = [
    new RedmineHeader({
      title: "headers.redmine.author",
      type: new RedmineEnum("author/name", {
        searchKey: "author_id",
        dropdownItems: users
      }),
      visible: true,
      searchable: true,
      orderByKey: "author",
    }),
    new RedmineHeader({
      title: "Assigned To",
      type: new RedmineEnum("assigned_to/name", {
        searchKey: "assigned_to_id",
        dropdownItems: users
      }),
      visible: true,
      searchable: true,
      orderByKey: "assigned_to",
    }),
    // new RedmineHeader({
    //   title: "globals.description",
    //   type: new RedmineString("description", {
    //     getHtml: (item, type) => {
    //       return (
    //         "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
    //         type.getString(item, type) +
    //         "</div>"
    //       );
    //     },
    //   }),
    //   visible: true,
    //   searchable: true,
    // }),
    new RedmineHeader({
      title: "globals.start_date",
      type: new RedmineDate("start_date"),
      visible: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "headers.download_centre.due_date",
      type: new RedmineDate("due_date"),
      visible: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "headers.redmine.done_ratio",
      type: new RedmineDecimal("done_ratio"),
      visible: true,
      searchable: true,
    }),
    // new RedmineHeader({
    //   title: "headers.redmine.is_private",
    //   type: new RedmineBoolean("is_private"),
    //   visible: true,
    //   searchable: true,
    // }),
    // new RedmineHeader({
    //   title: "headers.redmine.estimated_hours",
    //   type: new RedmineDecimal("estimated_hours"),
    //   visible: true,
    //   searchable: true,
    // }),
    new RedmineHeader({
      title: "Total Estimated Hours",
      type: new RedmineDecimal("total_estimated_hours"),
      visible: true,
      searchable: true,
    }),
    // new RedmineHeader({
    //   title: "Spent Hours",
    //   type: new RedmineDecimal("spent_hours"),
    //   visible: true,
    //   searchable: true,
    // }),
    new RedmineHeader({
      title: "Total Spent Hours",
      type: new RedmineDecimal("total_spent_hours"),
      visible: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "headers.member_files.created_on",
      type: new RedmineDateTime("created_on"),
      visible: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "Updated On",
      type: new RedmineDateTime("updated_on"),
      visible: true,
      searchable: true,
    }),
    new RedmineHeader({
      title: "headers.redmine.closed_on",
      type: new RedmineDateTime("closed_on"),
      visible: true,
      searchable: true,
    }),
  ]
  const memberHeader = new RedmineHeader({
    title: "globals.member",
    type: new RedmineString("custom_fields/Certificate", {
      getValue: (item) => {
        return item.custom_fields.filter(o=>o.id === 13)[0].value;
      },
      getHtml: (item, type) => {
        const link = `#/plan/${item.custom_fields.filter(o=>o.id === 10)[0].value}/members/${item.custom_fields.filter(o=>o.id === 9)[0].value}`
        if (item.custom_fields.filter(o=>o.id === 9).length > 0){
          return (
            `<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>
            <a href="${link}">${item.custom_fields.filter(o=>o.id === 13)[0].value}</a>
            </div>`
          );
        }
        return "";
      },
    }),
    visible: true,
    searchable: false,
  })
  if (showMember) {
    headers.push(memberHeader);
  }
  const planHeader = new RedmineHeader({
    title: "globals.plan",
    type: new RedmineString("custom_fields/Plan", {
      getValue: (item) => {
        return item.custom_fields.filter(o=>o.id === 11)[0].value;
      },
      getHtml: (item, type) => {
        const link = `#/plan/${item.custom_fields.filter(o=>o.id === 10)[0].value}/home`
        if (item.custom_fields.filter(o=>o.id === 10).length > 0){
          return (
            `<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>
            <a href="${link}">${item.custom_fields.filter(o=>o.id === 11)[0].value}</a>
            </div>`
          );
        }
        return "";
      },
    }),
    visible: true,
    searchable: false,
  })
  if (showPlan) {
    headers.push(planHeader);
  }
  return headers.concat(h2);
}

export default getHeaders;
